var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wrapper" },
    [
      _c(
        "side-bar",
        [
          _c("mobile-menu", { attrs: { slot: "content" }, slot: "content" }),
          _vm._v(" "),
          _vm._l(_vm.routes[0].children, function(route, index) {
            return route.meta.display
              ? _c(
                  "sidebar-link",
                  {
                    key: route.path,
                    class: { "sidebar-menu-item": route.children.length },
                    attrs: { to: route.path }
                  },
                  [
                    _c("i", { staticClass: "nc-icon", class: route.icon }),
                    _vm._v(" "),
                    _c("p", [_vm._v(_vm._s(route.name))]),
                    _vm._v(" "),
                    route.children.length && route.meta.childDisplay
                      ? _c("span", [
                          _c("i", {
                            staticClass: "fas fa-caret-down float-right m-0"
                          }),
                          _vm._v(" "),
                          _c("i", {
                            staticClass: "fas fa-caret-right float-right m-0"
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    route.children.length && route.meta.childDisplay
                      ? _c(
                          "ul",
                          { staticClass: "nav" },
                          _vm._l(route.children, function(cRoute, index) {
                            return cRoute.meta.display
                              ? _c(
                                  "sidebar-link",
                                  {
                                    key: cRoute.path,
                                    attrs: { to: cRoute.path }
                                  },
                                  [_c("p", [_vm._v(_vm._s(cRoute.name))])]
                                )
                              : _vm._e()
                          }),
                          1
                        )
                      : _vm._e()
                  ]
                )
              : _vm._e()
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "main-panel" },
        [
          _c("top-navbar"),
          _vm._v(" "),
          _c("dashboard-content", { on: { click: _vm.toggleSidebar } }),
          _vm._v(" "),
          _c("content-footer")
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-829f0bf8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-829f0bf8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Layout/DashboardLayout.vue
// module id = FIfX
// module chunks = 0